import { TableColumn } from 'react-data-table-component';

// eslint-disable-next-line no-shadow
export enum States {
  default = 'default',
  loading = 'loading',
}

// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  filter = 'filter',
  detail = 'detail',
  refuse = 'refuse',
}

export interface DataRow {
  event: string;
  recipient: string;
  bank: string;
  pixKey: string;
  transferValue: string;
  transferRequestDate: string;
  transferred: string;
  transferDate: string;
  action: string;
}

// eslint-disable-next-line no-shadow
export enum FormInput {
  filterSearch = 'filterSearch',
  inputSearch = 'inputSearch',
}

export const columns: TableColumn<DataRow>[] = [
  {
    name: 'Evento',
    selector: row => row.event,
    minWidth: '200px',
  },
  {
    name: 'Favorecido',
    selector: row => row.recipient,
    minWidth: '200px',
  },
  {
    name: 'Banco',
    selector: row => row.bank,
    minWidth: '80px',
  },
  {
    name: 'Chave',
    selector: row => row.pixKey,
    minWidth: '150px',
  },
  {
    name: 'Valor',
    selector: row => row.transferValue,
    width: '120px',
  },
  {
    name: 'Data solicitação',
    selector: row => row.transferRequestDate,
    width: '170px',
  },
  {
    name: 'Ações',
    selector: row => row.action,
    width: '170px',
  },
];

// eslint-disable-next-line no-shadow
export enum FormInputRefuse {
  id = 'id',
  refusedReason = 'refusedReason',
}
